import dayjs from 'dayjs';
import { ColumnProps } from 'primereact/column';
import { confirmDialog } from 'primereact/confirmdialog';

type BeforeExitParams = {
  onConfirm: () => void;
  message?: string;
};

export const beforeExit = ({ onConfirm, message }: BeforeExitParams) => {
  confirmDialog({
    message: message || 'Você tem certeza que deseja cancelar?',
    header: 'Atenção',
    icon: 'pi pi-info-circle',
    accept: onConfirm,
    acceptLabel: 'Sim',
    rejectLabel: 'Não',
    acceptClassName: 'button-danger',
    rejectClassName: 'button-primary',
  });
};

export const defaultColumnProps: (
  align?: 'left' | 'right' | 'center',
  sortable?: boolean,
) => Partial<ColumnProps> = (align = 'right', sortable = true) => ({
  sortable,
  className: 'col h-3rem',
  alignHeader: align,
  align,
});

export function formatStringDate(iso: string): string {
  const date = dayjs(iso);

  if (!date.isValid()) {
    return '-';
  }

  const isCurrentYear = date.year() === dayjs().year();
  const format = isCurrentYear ? 'DD/MM' : 'DD/MM/YYYY';

  return `${date.format(format)} às ${date.format('HH:mm')}`;
}
